const mandatoryFields = ['id', 'original_seat_id', 'mapped_seat_id', 'scenario_id'];
export default mandatoryFields;
